import { Container, Grid, Pagination } from "@mui/material";
import { FlexBetween } from "components/flex-box";
import ShopLayout1 from "components/layouts/ShopLayout1";
import Navbar from "components/navbar/Navbar";
import ShopCard1 from "components/shop/ShopCard1";
import { H2, Span } from "components/Typography";
import { useAppSelector } from "hooks/use-app-selector";
import modules from "modules";

const { selectors: branchesSelectors, actions: branchActions } = modules.branch;

const ShopList = () => {
  const branchasData = useAppSelector(branchesSelectors.selectBranches);
  return (
    <ShopLayout1 navbar={<Navbar />}>
      <Container sx={{ mt: 4, mb: 6 }}>
        <H2 mb={3}>All Branches</H2>

        <Grid container spacing={3}>
          {branchasData.map((item, ind) => (
            <Grid item lg={4} sm={6} xs={12} key={ind}>
              <ShopCard1 {...item} />
            </Grid>
          ))}
        </Grid>
      </Container>
    </ShopLayout1>
  );
};

export default ShopList;
